// Atribución de campaña. Se captura en el primer load de la app (index.js),
// porque el visitante puede navegar varias páginas antes de llegar al formulario.

export const LLAVE_CAMPANA = 'soha_campana';
export const PARAMS_CAMPANA = ['utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];

export function leerCampana() {
  try {
    return JSON.parse(window.sessionStorage.getItem(LLAVE_CAMPANA) || '{}') || {};
  } catch {
    return {};
  }
}

/** Guarda los parámetros de campaña de la URL sin sobrescribir los ya capturados. */
export function capturarCampana() {
  const guardada = leerCampana();
  const params = new URLSearchParams(window.location.search);
  let cambio = false;

  PARAMS_CAMPANA.forEach((p) => {
    const valor = params.get(p);
    if (valor && !guardada[p]) {
      guardada[p] = valor;
      cambio = true;
    }
  });

  if (cambio) {
    try {
      window.sessionStorage.setItem(LLAVE_CAMPANA, JSON.stringify(guardada));
    } catch {
      /* sessionStorage bloqueado: seguimos con los valores en memoria */
    }
  }
  return guardada;
}
